<template>
    <div>
        <div class="navtit">
            {{ $t("home.nav5") }}
        </div>
        <div class="banner">
            <img src="../assets/4.png" alt="" />
        </div>
        <div class="container">
            <el-row>
                <el-col :span="8">
                    <div class="contact-item">
                        <img src="../assets/map.png" />
                        <p>{{ $t("item4.tit1") }}</p>
                        <div class="txt">{{ $t("item4.txt") }}</div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="contact-item">
                        <img src="../assets/dianhua.png" />
                        <p>{{ $t("item4.tit2") }}</p>
                        <div class="txt">0351-5679309</div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="contact-item">
                        <img src="../assets/youjian.png" />
                        <p>{{ $t("item4.tit3") }}</p>
                        <div class="txt">030032</div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HomeView",
        data() {
            return {};
        },
        methods: {},
    };
</script>
<style scoped>
    .navtit {
        font-size: 36px;
        color: #000000;
        line-height: 45px;
        text-align: center;
        padding: 30px 60px;
    }
    .banner {
        width: 100%;
        height: 540px;
        margin: 0 auto;
        overflow: hidden;
    }
    .banner img {
        width: 100%;
        height: 100%;
    }
    .container {
        width: 1250px;
        margin: 0 auto;
        padding: 80px 0;
    }
    .contact-item {
        text-align: center;
    }
    .contact-item img {
        width: 36px;
    }
    .contact-item p {
        font-size: 18px;
        color: #4e4e4e;
        line-height: 30px;
        font-weight: bold;
    }
    .txt {
        font-size: 16px;
        color: #4e4e4e;
        line-height: 30px;
    }
</style>
